import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import CompanyForm from './CompanyForm';
import axios from 'axios';

function Company(props) {
    let [company, setCompany] = useState([]);
    useEffect(() => {
        axios.get(`/company`).then(res => {
            setCompany(res.data);
        });
    }, []);
    return (
        <>
            <h3>Korxona ma'lumotlari</h3>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <CompanyForm lang="uz" company={company.find(c => c.lang === 'uz')} />
                </Col>
                <Col span={12}>
                    <CompanyForm lang="ru" company={company.find(c => c.lang === 'ru')} />
                </Col>
            </Row>
        </>
    );
}

export default Company;